import React, { useState } from 'react';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import Price from '@FlightsComponents/Price';
import FlightItinerary from '@FlightsComponents/FlightItinerary';
import FlightItineraryModal from '@FlightsComponents/FlightItineraryModal';
import ViewItineraryButton from '@FlightsComponents/ViewItineraryButton';

import BoxContainer from '@shared/components/BoxContainer';
import SubsidiaryDetails from '@shared/components/SubsidiarySelectorContent/SubsidiaryDetails';

const DetailsComponent = ({
  infoFlightsSearch,
  flightValidate,
  flightsInUSD,
  isPayment,
  cardData,
}) => {
  const [showModal, setShowModal] = useState(false);

  const pageConfiguration = useSelector(store => store.pageConfiguration);
  const location = useLocation();

  const { formReserve } = location.state || {};
  const { selectedSubsidiary } = formReserve || {};

  const cluster = flightValidate?.cluster;

  const isBTC = pageConfiguration?.business_types?.code === 'BTC';

  // -----------------------------
  // BLOQUES
  // -----------------------------

  const PriceBlock = (
    <Price
      infoFlightsSearch={infoFlightsSearch}
      cluster={cluster}
      isInUSD={flightsInUSD?.isInUSD}
      cardData={cardData}
      isPayment={isPayment}
    />
  );

  const ItineraryBlock = (
    <Box>
      <FlightItinerary cluster={cluster} />

      <ViewItineraryButton onClick={() => setShowModal(true)} />

      <FlightItineraryModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        cluster={cluster}
      />
    </Box>
  );

  const SubsidiaryBlock =
    isBTC && selectedSubsidiary ? (
      <SubsidiaryDetails
        subsidiary={selectedSubsidiary}
        withLogo
        imageWidth={110}
        isPayment
      />
    ) : null;

  let layout = [];

  if (isPayment) {
    layout = [PriceBlock, SubsidiaryBlock];
  } else {
    layout = [ItineraryBlock, PriceBlock];
  }

  return (
    <BoxContainer>
      {layout.filter(Boolean).map((Block, index) => (
        <React.Fragment key={+index}>{Block}</React.Fragment>
      ))}
    </BoxContainer>
  );
};

export default DetailsComponent;
